import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map-pin-solid",
  "use": "map-pin-solid-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 24\" id=\"map-pin-solid\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M10 0A10 10 0 000 10a11.3 11.3 0 001.5 5.5 21 21 0 003.3 4.3 30.5 30.5 0 004.6 4 1 1 0 001.2 0 30.5 30.5 0 004.6-4 21 21 0 003.3-4.3A11.5 11.5 0 0020 10 10 10 0 0010 0zm0 14a4 4 0 114-4 4 4 0 01-4 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol